export default {
  default: () => import("/Users/prakash/Projects/personal/onlyfans-downloader/frontend/layouts/default.vue").then(m => m.default || m)
}